module.exports = __webpack_public_path__ + "static/media/w_w_hr_0.34d1f520.png";